import $ from 'jquery';

/**
 * The "Connect with Law School Alumni" module
 *
 * @module lawschool-connect
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-13 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-03 using ChatGPT
 */


class LawschoolConnect {

  constructor(element) {
    this.$el = $(element);
    this.setupBinds();
  }

  setupBinds() {
    this.$el.find('select').on('change', this.onLawschoolSelect.bind(this));
  }

  onLawschoolSelect(e) {
    window.location = `/people?lawSchool=${e.currentTarget.value}`;
  }

}

export default LawschoolConnect;
